import {Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow} from '@mui/material';
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import {ezprOrange} from '../../../_helpers';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Dialog with a table listing the available partners to pick from. Only one option can be selected.
 *
 * @param {PartnerFunctionPopup.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function PartnerFunctionPopup(props) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const columns = [
        {id: 'lifn2', label: `${props.partnerFunction === 'PI' ? 'Invoice presented by' : 'Ordering address'}`, width: 150},
        {id: 'name1', label: 'Name', width: 220},
        {id: 'ort01', label: 'Location', width: 150},
    ];

    return (props.open && // avoid computing render before its needed
        <Dialog
            open={props.open}
            maxWidth={'sm'}
            fullWidth={true}
        >
            <div className={'pr-popup-header'}>
                <DialogTitle>{`Select an ${props.partnerFunction === 'PI' ? 'Invoice Partner' : 'Ordering Address'}`}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={props.onClose}
                    sx={{
                        color: ezprOrange,
                    }}>
                    <CloseIcon
                        sx={{
                            width: '50px',
                            height: '50px',
                        }}
                    />
                </IconButton>
            </div>
            <DialogContent>
                <TableContainer sx={{maxHeight: '500px'}}>
                    <Table stickyHeader aria-label={'partners table'}>
                        <TableHead>
                            <TableRow className={'pr-editor-select-partner-popup-menu-header'} >
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        style={{width: column.width, background: '#DEDEDE'}}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.options
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((opt) => {
                                    return (
                                        <TableRow hover role={'checkbox'} tabIndex={-1} key={opt['lifn2']} onClick={() => props.onSelectOption(opt)}>
                                            {columns.map((column) => {
                                                const value = opt[column.id];
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component={'div'}
                    count={props.options.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </DialogContent>
        </Dialog>
    );
}

PartnerFunctionPopup.propTypes = {
    open: PropTypes.bool,
    partnerFunction: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    onSelectOption: PropTypes.func,
    onClose: PropTypes.func,
};
